/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { BulkHierarchicalEntityMutationRequest } from "../models/bulkHierarchicalEntityMutationRequest";

import type { ChildEntitiesSearchRequest } from "../models/childEntitiesSearchRequest";

import type { CloneEntityParams } from "../models/cloneEntityParams";

import type { CloneEntityRequest } from "../models/cloneEntityRequest";

import type { CustomComponentSearchRequest } from "../models/customComponentSearchRequest";

import type { DeployEntityRequest } from "../models/deployEntityRequest";

import type { DeployedEntity } from "../models/deployedEntity";

import type { DeployedEntityBulkFetchRequest } from "../models/deployedEntityBulkFetchRequest";

import type { DetectFileColumnsRequest } from "../models/detectFileColumnsRequest";

import type { EmbeddedDependentsResponse } from "../models/embeddedDependentsResponse";

import type { EmbeddedEntitiesSearchRequest } from "../models/embeddedEntitiesSearchRequest";

import type { Entity } from "../models/entity";

import type { EntityBulkFetchRequest } from "../models/entityBulkFetchRequest";

import type { EntityBulkFetchResponse } from "../models/entityBulkFetchResponse";

import type { EntityCopyRequest } from "../models/entityCopyRequest";

import type { EntityDependencyRequest } from "../models/entityDependencyRequest";

import type { EntityDependencyTree } from "../models/entityDependencyTree";

import type { EntityDependentsWithAssetsRequest } from "../models/entityDependentsWithAssetsRequest";

import type { EntityDependentsWithAssetsResponse } from "../models/entityDependentsWithAssetsResponse";

import type { EntityDistinctValuesRequest } from "../models/entityDistinctValuesRequest";

import type { EntityExportRequest } from "../models/entityExportRequest";

import type { EntityImportFieldMapping } from "../models/entityImportFieldMapping";

import type { EntityImportRequest } from "../models/entityImportRequest";

import type { EntityMutationResponse } from "../models/entityMutationResponse";

import type { EntitySyncPullRequest } from "../models/entitySyncPullRequest";

import type { EntitySyncPullResponse } from "../models/entitySyncPullResponse";

import type { EntitySyncPushRequest } from "../models/entitySyncPushRequest";

import type { EntitySyncPushResponse } from "../models/entitySyncPushResponse";

import type { FileColumn } from "../models/fileColumn";

import type { FindByIdsRequest } from "../models/findByIdsRequest";

import type { GetDeployedEntitySnapshotParams } from "../models/getDeployedEntitySnapshotParams";

import type { GetEntitySnapshotParams } from "../models/getEntitySnapshotParams";

import type { GetLatestVersion200 } from "../models/getLatestVersion200";

import type { HierarchicalEntityMutationRequest } from "../models/hierarchicalEntityMutationRequest";

import type { HitsEntity1 } from "../models/hitsEntity1";

import type { ImportFieldMappingRequest } from "../models/importFieldMappingRequest";

import type { ImportPreviewResponse } from "../models/importPreviewResponse";

import type { InterfacePageEmbeddedRequest } from "../models/interfacePageEmbeddedRequest";

import type { NamespaceSearchRequest } from "../models/namespaceSearchRequest";

import type { Query } from "../models/query";

import type { RestoreEntityParams } from "../models/restoreEntityParams";

import type { SaveAndDeployEntityParams } from "../models/saveAndDeployEntityParams";

import type { Update } from "../models/update";

import type { UpdateEntityByIdParams } from "../models/updateEntityByIdParams";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Create Entity
 */
export const createEntity = (
  entity: Entity,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entity,
      signal,
    },
    options,
  );
};

export const getCreateEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntity>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEntity>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationKey = ["createEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEntity>>,
    { data: Entity }
  > = (props, context) => {
    const { data } = props ?? {};

    return createEntity(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEntity>>
>;
export type CreateEntityMutationBody = Entity;
export type CreateEntityMutationError = ErrorType<unknown>;

/**
 * @summary Create Entity
 */
export const useCreateEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEntity>>,
      TError,
      { data: Entity },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEntity>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationOptions = getCreateEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save And Deploy Entity
 */
export const saveAndDeployEntity = (
  entity: Entity,
  params?: SaveAndDeployEntityParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/action/saveAndDeploy`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entity,
      params,
      signal,
    },
    options,
  );
};

export const getSaveAndDeployEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveAndDeployEntity>>,
    TError,
    { data: Entity; params?: SaveAndDeployEntityParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveAndDeployEntity>>,
  TError,
  { data: Entity; params?: SaveAndDeployEntityParams },
  TContext
> => {
  const mutationKey = ["saveAndDeployEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveAndDeployEntity>>,
    { data: Entity; params?: SaveAndDeployEntityParams }
  > = (props, context) => {
    const { data, params } = props ?? {};

    return saveAndDeployEntity(data, params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveAndDeployEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveAndDeployEntity>>
>;
export type SaveAndDeployEntityMutationBody = Entity;
export type SaveAndDeployEntityMutationError = ErrorType<unknown>;

/**
 * @summary Save And Deploy Entity
 */
export const useSaveAndDeployEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveAndDeployEntity>>,
      TError,
      { data: Entity; params?: SaveAndDeployEntityParams },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveAndDeployEntity>>,
  TError,
  { data: Entity; params?: SaveAndDeployEntityParams },
  TContext
> => {
  const mutationOptions = getSaveAndDeployEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Bulk Fetch Entities
 */
export const bulkFetchEntities = (
  entityBulkFetchRequest: EntityBulkFetchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityBulkFetchResponse>(
    {
      url: `/api/entity/bulk-fetch`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityBulkFetchRequest,
      signal,
    },
    options,
  );
};

export const getBulkFetchEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkFetchEntities>>,
    TError,
    { data: EntityBulkFetchRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkFetchEntities>>,
  TError,
  { data: EntityBulkFetchRequest },
  TContext
> => {
  const mutationKey = ["bulkFetchEntities"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkFetchEntities>>,
    { data: EntityBulkFetchRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return bulkFetchEntities(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkFetchEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkFetchEntities>>
>;
export type BulkFetchEntitiesMutationBody = EntityBulkFetchRequest;
export type BulkFetchEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Bulk Fetch Entities
 */
export const useBulkFetchEntities = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkFetchEntities>>,
      TError,
      { data: EntityBulkFetchRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkFetchEntities>>,
  TError,
  { data: EntityBulkFetchRequest },
  TContext
> => {
  const mutationOptions = getBulkFetchEntitiesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Bulk Fetch Deployed Entity Snapshots
 */
export const bulkFetchEntitySnapshots = (
  entityBulkFetchRequest: EntityBulkFetchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityBulkFetchResponse>(
    {
      url: `/api/entity/deployed/bulk-fetch-snapshots`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityBulkFetchRequest,
      signal,
    },
    options,
  );
};

export const getBulkFetchEntitySnapshotsQueryKey = (
  entityBulkFetchRequest?: EntityBulkFetchRequest,
) => {
  return [
    `/api/entity/deployed/bulk-fetch-snapshots`,
    entityBulkFetchRequest,
  ] as const;
};

export const getBulkFetchEntitySnapshotsQueryOptions = <
  TData = Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
  TError = ErrorType<unknown>,
>(
  entityBulkFetchRequest: EntityBulkFetchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBulkFetchEntitySnapshotsQueryKey(entityBulkFetchRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>
  > = ({ signal, meta }) =>
    bulkFetchEntitySnapshots(
      entityBulkFetchRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BulkFetchEntitySnapshotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>
>;
export type BulkFetchEntitySnapshotsQueryError = ErrorType<unknown>;

export function useBulkFetchEntitySnapshots<
  TData = Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
  TError = ErrorType<unknown>,
>(
  entityBulkFetchRequest: EntityBulkFetchRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
          TError,
          Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBulkFetchEntitySnapshots<
  TData = Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
  TError = ErrorType<unknown>,
>(
  entityBulkFetchRequest: EntityBulkFetchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
          TError,
          Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBulkFetchEntitySnapshots<
  TData = Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
  TError = ErrorType<unknown>,
>(
  entityBulkFetchRequest: EntityBulkFetchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Bulk Fetch Deployed Entity Snapshots
 */

export function useBulkFetchEntitySnapshots<
  TData = Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
  TError = ErrorType<unknown>,
>(
  entityBulkFetchRequest: EntityBulkFetchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBulkFetchEntitySnapshotsQueryOptions(
    entityBulkFetchRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Bulk Fetch Deployed Entity Snapshots
 */
export const prefetchBulkFetchEntitySnapshots = async <
  TData = Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityBulkFetchRequest: EntityBulkFetchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bulkFetchEntitySnapshots>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getBulkFetchEntitySnapshotsQueryOptions(
    entityBulkFetchRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Create Entity And Get Violations
 */
export const createEntityAndGetViolations = (
  entity: Entity,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityMutationResponse>(
    {
      url: `/api/entity/checkAndCreate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entity,
      signal,
    },
    options,
  );
};

export const getCreateEntityAndGetViolationsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntityAndGetViolations>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEntityAndGetViolations>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationKey = ["createEntityAndGetViolations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEntityAndGetViolations>>,
    { data: Entity }
  > = (props, context) => {
    const { data } = props ?? {};

    return createEntityAndGetViolations(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEntityAndGetViolationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEntityAndGetViolations>>
>;
export type CreateEntityAndGetViolationsMutationBody = Entity;
export type CreateEntityAndGetViolationsMutationError = ErrorType<unknown>;

/**
 * @summary Create Entity And Get Violations
 */
export const useCreateEntityAndGetViolations = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEntityAndGetViolations>>,
      TError,
      { data: Entity },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEntityAndGetViolations>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationOptions =
    getCreateEntityAndGetViolationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Entity And Get Violations
 */
export const updateEntityAndGetViolations = (
  entity: Entity,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityMutationResponse>(
    {
      url: `/api/entity/checkAndUpdate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entity,
      signal,
    },
    options,
  );
};

export const getUpdateEntityAndGetViolationsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEntityAndGetViolations>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEntityAndGetViolations>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationKey = ["updateEntityAndGetViolations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEntityAndGetViolations>>,
    { data: Entity }
  > = (props, context) => {
    const { data } = props ?? {};

    return updateEntityAndGetViolations(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEntityAndGetViolationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEntityAndGetViolations>>
>;
export type UpdateEntityAndGetViolationsMutationBody = Entity;
export type UpdateEntityAndGetViolationsMutationError = ErrorType<unknown>;

/**
 * @summary Update Entity And Get Violations
 */
export const useUpdateEntityAndGetViolations = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEntityAndGetViolations>>,
      TError,
      { data: Entity },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEntityAndGetViolations>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationOptions =
    getUpdateEntityAndGetViolationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Search Dependent Entities
 */
export const searchChildEntities = (
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/child-entities`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: childEntitiesSearchRequest,
      signal,
    },
    options,
  );
};

export const getSearchChildEntitiesQueryKey = (
  childEntitiesSearchRequest?: ChildEntitiesSearchRequest,
) => {
  return [`/api/entity/child-entities`, childEntitiesSearchRequest] as const;
};

export const getSearchChildEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchChildEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchChildEntitiesQueryKey(childEntitiesSearchRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchChildEntities>>
  > = ({ signal, meta }) =>
    searchChildEntities(
      childEntitiesSearchRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchChildEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchChildEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchChildEntities>>
>;
export type SearchChildEntitiesQueryError = ErrorType<unknown>;

export function useSearchChildEntities<
  TData = Awaited<ReturnType<typeof searchChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchChildEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchChildEntities>>,
          TError,
          Awaited<ReturnType<typeof searchChildEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchChildEntities<
  TData = Awaited<ReturnType<typeof searchChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchChildEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchChildEntities>>,
          TError,
          Awaited<ReturnType<typeof searchChildEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchChildEntities<
  TData = Awaited<ReturnType<typeof searchChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchChildEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Dependent Entities
 */

export function useSearchChildEntities<
  TData = Awaited<ReturnType<typeof searchChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchChildEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchChildEntitiesQueryOptions(
    childEntitiesSearchRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Dependent Entities
 */
export const prefetchSearchChildEntities = async <
  TData = Awaited<ReturnType<typeof searchChildEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchChildEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchChildEntitiesQueryOptions(
    childEntitiesSearchRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Clone Entity
 */
export const cloneEntity = (
  entityType: string,
  entityId: string,
  cloneEntityRequest: CloneEntityRequest,
  params?: CloneEntityParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/clone/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cloneEntityRequest,
      params,
      signal,
    },
    options,
  );
};

export const getCloneEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneEntity>>,
    TError,
    {
      entityType: string;
      entityId: string;
      data: CloneEntityRequest;
      params?: CloneEntityParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneEntity>>,
  TError,
  {
    entityType: string;
    entityId: string;
    data: CloneEntityRequest;
    params?: CloneEntityParams;
  },
  TContext
> => {
  const mutationKey = ["cloneEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneEntity>>,
    {
      entityType: string;
      entityId: string;
      data: CloneEntityRequest;
      params?: CloneEntityParams;
    }
  > = (props, context) => {
    const { entityType, entityId, data, params } = props ?? {};

    return cloneEntity(entityType, entityId, data, params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CloneEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof cloneEntity>>
>;
export type CloneEntityMutationBody = CloneEntityRequest;
export type CloneEntityMutationError = ErrorType<unknown>;

/**
 * @summary Clone Entity
 */
export const useCloneEntity = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cloneEntity>>,
      TError,
      {
        entityType: string;
        entityId: string;
        data: CloneEntityRequest;
        params?: CloneEntityParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cloneEntity>>,
  TError,
  {
    entityType: string;
    entityId: string;
    data: CloneEntityRequest;
    params?: CloneEntityParams;
  },
  TContext
> => {
  const mutationOptions = getCloneEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Copy Entity
 */
export const copyEntity = (
  entityCopyRequest: EntityCopyRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/copyEntity`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityCopyRequest,
      signal,
    },
    options,
  );
};

export const getCopyEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyEntity>>,
    TError,
    { data: EntityCopyRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyEntity>>,
  TError,
  { data: EntityCopyRequest },
  TContext
> => {
  const mutationKey = ["copyEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyEntity>>,
    { data: EntityCopyRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return copyEntity(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyEntity>>
>;
export type CopyEntityMutationBody = EntityCopyRequest;
export type CopyEntityMutationError = ErrorType<unknown>;

/**
 * @summary Copy Entity
 */
export const useCopyEntity = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof copyEntity>>,
      TError,
      { data: EntityCopyRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof copyEntity>>,
  TError,
  { data: EntityCopyRequest },
  TContext
> => {
  const mutationOptions = getCopyEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Count Activities After Last Publish
 */
export const countActivitiesAfterLastPublish = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/entity/count-activities-after-last-publish/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getCountActivitiesAfterLastPublishQueryKey = (
  entityType?: string,
  entityId?: string,
) => {
  return [
    `/api/entity/count-activities-after-last-publish/${entityType}/${entityId}`,
  ] as const;
};

export const getCountActivitiesAfterLastPublishQueryOptions = <
  TData = Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountActivitiesAfterLastPublishQueryKey(entityType, entityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>
  > = ({ signal, meta }) =>
    countActivitiesAfterLastPublish(
      entityType,
      entityId,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountActivitiesAfterLastPublishQueryResult = NonNullable<
  Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>
>;
export type CountActivitiesAfterLastPublishQueryError = ErrorType<unknown>;

export function useCountActivitiesAfterLastPublish<
  TData = Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
          TError,
          Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountActivitiesAfterLastPublish<
  TData = Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
          TError,
          Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountActivitiesAfterLastPublish<
  TData = Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Count Activities After Last Publish
 */

export function useCountActivitiesAfterLastPublish<
  TData = Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCountActivitiesAfterLastPublishQueryOptions(
    entityType,
    entityId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Count Activities After Last Publish
 */
export const prefetchCountActivitiesAfterLastPublish = async <
  TData = Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countActivitiesAfterLastPublish>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getCountActivitiesAfterLastPublishQueryOptions(
    entityType,
    entityId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Create Hierarchical Entity
 */
export const createUpdateOrDeleteHierarchicalEntity = (
  hierarchicalEntityMutationRequest: HierarchicalEntityMutationRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity[]>(
    {
      url: `/api/entity/create-update-or-delete/hierarchical`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: hierarchicalEntityMutationRequest,
      signal,
    },
    options,
  );
};

export const getCreateUpdateOrDeleteHierarchicalEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>,
    TError,
    { data: HierarchicalEntityMutationRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>,
  TError,
  { data: HierarchicalEntityMutationRequest },
  TContext
> => {
  const mutationKey = ["createUpdateOrDeleteHierarchicalEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>,
    { data: HierarchicalEntityMutationRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return createUpdateOrDeleteHierarchicalEntity(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUpdateOrDeleteHierarchicalEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>
>;
export type CreateUpdateOrDeleteHierarchicalEntityMutationBody =
  HierarchicalEntityMutationRequest;
export type CreateUpdateOrDeleteHierarchicalEntityMutationError =
  ErrorType<unknown>;

/**
 * @summary Create Hierarchical Entity
 */
export const useCreateUpdateOrDeleteHierarchicalEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>,
      TError,
      { data: HierarchicalEntityMutationRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>,
  TError,
  { data: HierarchicalEntityMutationRequest },
  TContext
> => {
  const mutationOptions =
    getCreateUpdateOrDeleteHierarchicalEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Bulk Create Hierarchical Entity
 */
export const bulkCreateUpdateOrDeleteHierarchicalEntity = (
  bulkHierarchicalEntityMutationRequest: BulkHierarchicalEntityMutationRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity[]>(
    {
      url: `/api/entity/create-update-or-delete/hierarchical/bulk`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bulkHierarchicalEntityMutationRequest,
      signal,
    },
    options,
  );
};

export const getBulkCreateUpdateOrDeleteHierarchicalEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkCreateUpdateOrDeleteHierarchicalEntity>>,
    TError,
    { data: BulkHierarchicalEntityMutationRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkCreateUpdateOrDeleteHierarchicalEntity>>,
  TError,
  { data: BulkHierarchicalEntityMutationRequest },
  TContext
> => {
  const mutationKey = ["bulkCreateUpdateOrDeleteHierarchicalEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkCreateUpdateOrDeleteHierarchicalEntity>>,
    { data: BulkHierarchicalEntityMutationRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return bulkCreateUpdateOrDeleteHierarchicalEntity(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkCreateUpdateOrDeleteHierarchicalEntityMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bulkCreateUpdateOrDeleteHierarchicalEntity>>
  >;
export type BulkCreateUpdateOrDeleteHierarchicalEntityMutationBody =
  BulkHierarchicalEntityMutationRequest;
export type BulkCreateUpdateOrDeleteHierarchicalEntityMutationError =
  ErrorType<unknown>;

/**
 * @summary Bulk Create Hierarchical Entity
 */
export const useBulkCreateUpdateOrDeleteHierarchicalEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkCreateUpdateOrDeleteHierarchicalEntity>>,
      TError,
      { data: BulkHierarchicalEntityMutationRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkCreateUpdateOrDeleteHierarchicalEntity>>,
  TError,
  { data: BulkHierarchicalEntityMutationRequest },
  TContext
> => {
  const mutationOptions =
    getBulkCreateUpdateOrDeleteHierarchicalEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Bulk Fetch Deployed Entities
 */
export const deployedBulkFetchEntities = (
  deployedEntityBulkFetchRequest: DeployedEntityBulkFetchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityBulkFetchResponse>(
    {
      url: `/api/entity/deployed/bulk-fetch`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deployedEntityBulkFetchRequest,
      signal,
    },
    options,
  );
};

export const getDeployedBulkFetchEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deployedBulkFetchEntities>>,
    TError,
    { data: DeployedEntityBulkFetchRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deployedBulkFetchEntities>>,
  TError,
  { data: DeployedEntityBulkFetchRequest },
  TContext
> => {
  const mutationKey = ["deployedBulkFetchEntities"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deployedBulkFetchEntities>>,
    { data: DeployedEntityBulkFetchRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return deployedBulkFetchEntities(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type DeployedBulkFetchEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deployedBulkFetchEntities>>
>;
export type DeployedBulkFetchEntitiesMutationBody =
  DeployedEntityBulkFetchRequest;
export type DeployedBulkFetchEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Bulk Fetch Deployed Entities
 */
export const useDeployedBulkFetchEntities = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deployedBulkFetchEntities>>,
      TError,
      { data: DeployedEntityBulkFetchRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deployedBulkFetchEntities>>,
  TError,
  { data: DeployedEntityBulkFetchRequest },
  TContext
> => {
  const mutationOptions = getDeployedBulkFetchEntitiesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Search Dependent Deployed Entities
 */
export const searchDeployedChildEntities = (
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/deployed/child-entities`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: childEntitiesSearchRequest,
      signal,
    },
    options,
  );
};

export const getSearchDeployedChildEntitiesQueryKey = (
  childEntitiesSearchRequest?: ChildEntitiesSearchRequest,
) => {
  return [
    `/api/entity/deployed/child-entities`,
    childEntitiesSearchRequest,
  ] as const;
};

export const getSearchDeployedChildEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchDeployedChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedChildEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchDeployedChildEntitiesQueryKey(childEntitiesSearchRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchDeployedChildEntities>>
  > = ({ signal, meta }) =>
    searchDeployedChildEntities(
      childEntitiesSearchRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDeployedChildEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchDeployedChildEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchDeployedChildEntities>>
>;
export type SearchDeployedChildEntitiesQueryError = ErrorType<unknown>;

export function useSearchDeployedChildEntities<
  TData = Awaited<ReturnType<typeof searchDeployedChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedChildEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDeployedChildEntities>>,
          TError,
          Awaited<ReturnType<typeof searchDeployedChildEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedChildEntities<
  TData = Awaited<ReturnType<typeof searchDeployedChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedChildEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDeployedChildEntities>>,
          TError,
          Awaited<ReturnType<typeof searchDeployedChildEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedChildEntities<
  TData = Awaited<ReturnType<typeof searchDeployedChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedChildEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Dependent Deployed Entities
 */

export function useSearchDeployedChildEntities<
  TData = Awaited<ReturnType<typeof searchDeployedChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedChildEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchDeployedChildEntitiesQueryOptions(
    childEntitiesSearchRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Dependent Deployed Entities
 */
export const prefetchSearchDeployedChildEntities = async <
  TData = Awaited<ReturnType<typeof searchDeployedChildEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedChildEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchDeployedChildEntitiesQueryOptions(
    childEntitiesSearchRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Deployed Custom Components
 */
export const searchDeployedCustomComponents = (
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/deployed/e_custom_component/search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customComponentSearchRequest,
      signal,
    },
    options,
  );
};

export const getSearchDeployedCustomComponentsQueryKey = (
  customComponentSearchRequest?: CustomComponentSearchRequest,
) => {
  return [
    `/api/entity/deployed/e_custom_component/search`,
    customComponentSearchRequest,
  ] as const;
};

export const getSearchDeployedCustomComponentsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchDeployedCustomComponentsQueryKey(customComponentSearchRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchDeployedCustomComponents>>
  > = ({ signal, meta }) =>
    searchDeployedCustomComponents(
      customComponentSearchRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchDeployedCustomComponentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchDeployedCustomComponents>>
>;
export type SearchDeployedCustomComponentsQueryError = ErrorType<unknown>;

export function useSearchDeployedCustomComponents<
  TData = Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  customComponentSearchRequest: CustomComponentSearchRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
          TError,
          Awaited<ReturnType<typeof searchDeployedCustomComponents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedCustomComponents<
  TData = Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
          TError,
          Awaited<ReturnType<typeof searchDeployedCustomComponents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedCustomComponents<
  TData = Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Deployed Custom Components
 */

export function useSearchDeployedCustomComponents<
  TData = Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchDeployedCustomComponentsQueryOptions(
    customComponentSearchRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Deployed Custom Components
 */
export const prefetchSearchDeployedCustomComponents = async <
  TData = Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedCustomComponents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchDeployedCustomComponentsQueryOptions(
    customComponentSearchRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Deployed Namespaces
 */
export const searchDeployedNamespaces = (
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/deployed/e_i18n_namespace/search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: namespaceSearchRequest,
      signal,
    },
    options,
  );
};

export const getSearchDeployedNamespacesQueryKey = (
  namespaceSearchRequest?: NamespaceSearchRequest,
) => {
  return [
    `/api/entity/deployed/e_i18n_namespace/search`,
    namespaceSearchRequest,
  ] as const;
};

export const getSearchDeployedNamespacesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchDeployedNamespaces>>,
  TError = ErrorType<unknown>,
>(
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedNamespaces>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchDeployedNamespacesQueryKey(namespaceSearchRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchDeployedNamespaces>>
  > = ({ signal, meta }) =>
    searchDeployedNamespaces(
      namespaceSearchRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDeployedNamespaces>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchDeployedNamespacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchDeployedNamespaces>>
>;
export type SearchDeployedNamespacesQueryError = ErrorType<unknown>;

export function useSearchDeployedNamespaces<
  TData = Awaited<ReturnType<typeof searchDeployedNamespaces>>,
  TError = ErrorType<unknown>,
>(
  namespaceSearchRequest: NamespaceSearchRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedNamespaces>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDeployedNamespaces>>,
          TError,
          Awaited<ReturnType<typeof searchDeployedNamespaces>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedNamespaces<
  TData = Awaited<ReturnType<typeof searchDeployedNamespaces>>,
  TError = ErrorType<unknown>,
>(
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedNamespaces>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDeployedNamespaces>>,
          TError,
          Awaited<ReturnType<typeof searchDeployedNamespaces>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedNamespaces<
  TData = Awaited<ReturnType<typeof searchDeployedNamespaces>>,
  TError = ErrorType<unknown>,
>(
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedNamespaces>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Deployed Namespaces
 */

export function useSearchDeployedNamespaces<
  TData = Awaited<ReturnType<typeof searchDeployedNamespaces>>,
  TError = ErrorType<unknown>,
>(
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedNamespaces>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchDeployedNamespacesQueryOptions(
    namespaceSearchRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Deployed Namespaces
 */
export const prefetchSearchDeployedNamespaces = async <
  TData = Awaited<ReturnType<typeof searchDeployedNamespaces>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedNamespaces>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchDeployedNamespacesQueryOptions(
    namespaceSearchRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Deployed Interface Override
 */
export const findDeployedInterfaceOverride = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<DeployedEntity>(
    { url: `/api/entity/deployed/e_interface_override`, method: "GET", signal },
    options,
  );
};

export const getFindDeployedInterfaceOverrideQueryKey = () => {
  return [`/api/entity/deployed/e_interface_override`] as const;
};

export const getFindDeployedInterfaceOverrideQueryOptions = <
  TData = Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindDeployedInterfaceOverrideQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findDeployedInterfaceOverride>>
  > = ({ signal, meta }) =>
    findDeployedInterfaceOverride({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindDeployedInterfaceOverrideQueryResult = NonNullable<
  Awaited<ReturnType<typeof findDeployedInterfaceOverride>>
>;
export type FindDeployedInterfaceOverrideQueryError = ErrorType<unknown>;

export function useFindDeployedInterfaceOverride<
  TData = Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
          TError,
          Awaited<ReturnType<typeof findDeployedInterfaceOverride>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindDeployedInterfaceOverride<
  TData = Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
          TError,
          Awaited<ReturnType<typeof findDeployedInterfaceOverride>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindDeployedInterfaceOverride<
  TData = Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Deployed Interface Override
 */

export function useFindDeployedInterfaceOverride<
  TData = Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindDeployedInterfaceOverrideQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Deployed Interface Override
 */
export const prefetchFindDeployedInterfaceOverride = async <
  TData = Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedInterfaceOverride>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindDeployedInterfaceOverrideQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Fetch Deployed Embedded Dependents
 */
export const fetchDeployedEmbeddedDependents = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EmbeddedDependentsResponse>(
    {
      url: `/api/entity/deployed/embedded-dependents/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getFetchDeployedEmbeddedDependentsQueryKey = (
  entityType?: string,
  entityId?: string,
) => {
  return [
    `/api/entity/deployed/embedded-dependents/${entityType}/${entityId}`,
  ] as const;
};

export const getFetchDeployedEmbeddedDependentsQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFetchDeployedEmbeddedDependentsQueryKey(entityType, entityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>
  > = ({ signal, meta }) =>
    fetchDeployedEmbeddedDependents(
      entityType,
      entityId,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchDeployedEmbeddedDependentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>
>;
export type FetchDeployedEmbeddedDependentsQueryError = ErrorType<unknown>;

export function useFetchDeployedEmbeddedDependents<
  TData = Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
          TError,
          Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchDeployedEmbeddedDependents<
  TData = Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
          TError,
          Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchDeployedEmbeddedDependents<
  TData = Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Deployed Embedded Dependents
 */

export function useFetchDeployedEmbeddedDependents<
  TData = Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchDeployedEmbeddedDependentsQueryOptions(
    entityType,
    entityId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetch Deployed Embedded Dependents
 */
export const prefetchFetchDeployedEmbeddedDependents = async <
  TData = Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchDeployedEmbeddedDependents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFetchDeployedEmbeddedDependentsQueryOptions(
    entityType,
    entityId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Deployed Embedded Entities
 */
export const searchDeployedEmbeddedEntities = (
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EmbeddedDependentsResponse>(
    {
      url: `/api/entity/deployed/embedded-entities`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: embeddedEntitiesSearchRequest,
      signal,
    },
    options,
  );
};

export const getSearchDeployedEmbeddedEntitiesQueryKey = (
  embeddedEntitiesSearchRequest?: EmbeddedEntitiesSearchRequest,
) => {
  return [
    `/api/entity/deployed/embedded-entities`,
    embeddedEntitiesSearchRequest,
  ] as const;
};

export const getSearchDeployedEmbeddedEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchDeployedEmbeddedEntitiesQueryKey(embeddedEntitiesSearchRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>
  > = ({ signal, meta }) =>
    searchDeployedEmbeddedEntities(
      embeddedEntitiesSearchRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchDeployedEmbeddedEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>
>;
export type SearchDeployedEmbeddedEntitiesQueryError = ErrorType<unknown>;

export function useSearchDeployedEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
          TError,
          Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
          TError,
          Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Deployed Embedded Entities
 */

export function useSearchDeployedEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchDeployedEmbeddedEntitiesQueryOptions(
    embeddedEntitiesSearchRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Deployed Embedded Entities
 */
export const prefetchSearchDeployedEmbeddedEntities = async <
  TData = Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchDeployedEmbeddedEntitiesQueryOptions(
    embeddedEntitiesSearchRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Deployed Interface Page Embedded Entities
 */
export const searchDeployedInterfacePageEmbeddedEntities = (
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EmbeddedDependentsResponse>(
    {
      url: `/api/entity/deployed/embedded-entities/e_component`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: interfacePageEmbeddedRequest,
      signal,
    },
    options,
  );
};

export const getSearchDeployedInterfacePageEmbeddedEntitiesQueryKey = (
  interfacePageEmbeddedRequest?: InterfacePageEmbeddedRequest,
) => {
  return [
    `/api/entity/deployed/embedded-entities/e_component`,
    interfacePageEmbeddedRequest,
  ] as const;
};

export const getSearchDeployedInterfacePageEmbeddedEntitiesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>
  >,
  TError = ErrorType<unknown>,
>(
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchDeployedInterfacePageEmbeddedEntitiesQueryKey(
      interfacePageEmbeddedRequest,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>>
  > = ({ signal, meta }) =>
    searchDeployedInterfacePageEmbeddedEntities(
      interfacePageEmbeddedRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchDeployedInterfacePageEmbeddedEntitiesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>>
  >;
export type SearchDeployedInterfacePageEmbeddedEntitiesQueryError =
  ErrorType<unknown>;

export function useSearchDeployedInterfacePageEmbeddedEntities<
  TData = Awaited<
    ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>
  >,
  TError = ErrorType<unknown>,
>(
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>
          >,
          TError,
          Awaited<
            ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedInterfacePageEmbeddedEntities<
  TData = Awaited<
    ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>
  >,
  TError = ErrorType<unknown>,
>(
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>
          >,
          TError,
          Awaited<
            ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedInterfacePageEmbeddedEntities<
  TData = Awaited<
    ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>
  >,
  TError = ErrorType<unknown>,
>(
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Deployed Interface Page Embedded Entities
 */

export function useSearchDeployedInterfacePageEmbeddedEntities<
  TData = Awaited<
    ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>
  >,
  TError = ErrorType<unknown>,
>(
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getSearchDeployedInterfacePageEmbeddedEntitiesQueryOptions(
      interfacePageEmbeddedRequest,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Deployed Interface Page Embedded Entities
 */
export const prefetchSearchDeployedInterfacePageEmbeddedEntities = async <
  TData = Awaited<
    ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>
  >,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions =
    getSearchDeployedInterfacePageEmbeddedEntitiesQueryOptions(
      interfacePageEmbeddedRequest,
      options,
    );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Deployed Entity Dependency Tree
 */
export const getDeployedEntityDependency = (
  entityDependencyRequest: EntityDependencyRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityDependencyTree>(
    {
      url: `/api/entity/deployed/entity-dependency`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityDependencyRequest,
      signal,
    },
    options,
  );
};

export const getGetDeployedEntityDependencyQueryKey = (
  entityDependencyRequest?: EntityDependencyRequest,
) => {
  return [
    `/api/entity/deployed/entity-dependency`,
    entityDependencyRequest,
  ] as const;
};

export const getGetDeployedEntityDependencyQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeployedEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  entityDependencyRequest: EntityDependencyRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependency>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeployedEntityDependencyQueryKey(entityDependencyRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeployedEntityDependency>>
  > = ({ signal, meta }) =>
    getDeployedEntityDependency(
      entityDependencyRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeployedEntityDependency>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeployedEntityDependencyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeployedEntityDependency>>
>;
export type GetDeployedEntityDependencyQueryError = ErrorType<unknown>;

export function useGetDeployedEntityDependency<
  TData = Awaited<ReturnType<typeof getDeployedEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  entityDependencyRequest: EntityDependencyRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependency>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeployedEntityDependency>>,
          TError,
          Awaited<ReturnType<typeof getDeployedEntityDependency>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeployedEntityDependency<
  TData = Awaited<ReturnType<typeof getDeployedEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  entityDependencyRequest: EntityDependencyRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependency>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeployedEntityDependency>>,
          TError,
          Awaited<ReturnType<typeof getDeployedEntityDependency>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeployedEntityDependency<
  TData = Awaited<ReturnType<typeof getDeployedEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  entityDependencyRequest: EntityDependencyRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependency>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Deployed Entity Dependency Tree
 */

export function useGetDeployedEntityDependency<
  TData = Awaited<ReturnType<typeof getDeployedEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  entityDependencyRequest: EntityDependencyRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependency>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeployedEntityDependencyQueryOptions(
    entityDependencyRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Deployed Entity Dependency Tree
 */
export const prefetchGetDeployedEntityDependency = async <
  TData = Awaited<ReturnType<typeof getDeployedEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityDependencyRequest: EntityDependencyRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependency>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetDeployedEntityDependencyQueryOptions(
    entityDependencyRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Deployed Entity Dependents With Assets
 */
export const deployedEntityDependentsWithAssets = (
  entityDependentsWithAssetsRequest: EntityDependentsWithAssetsRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityDependentsWithAssetsResponse>(
    {
      url: `/api/entity/deployed/entity-dependents-with-assets`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityDependentsWithAssetsRequest,
      signal,
    },
    options,
  );
};

export const getDeployedEntityDependentsWithAssetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deployedEntityDependentsWithAssets>>,
    TError,
    { data: EntityDependentsWithAssetsRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deployedEntityDependentsWithAssets>>,
  TError,
  { data: EntityDependentsWithAssetsRequest },
  TContext
> => {
  const mutationKey = ["deployedEntityDependentsWithAssets"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deployedEntityDependentsWithAssets>>,
    { data: EntityDependentsWithAssetsRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return deployedEntityDependentsWithAssets(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type DeployedEntityDependentsWithAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deployedEntityDependentsWithAssets>>
>;
export type DeployedEntityDependentsWithAssetsMutationBody =
  EntityDependentsWithAssetsRequest;
export type DeployedEntityDependentsWithAssetsMutationError =
  ErrorType<unknown>;

/**
 * @summary Deployed Entity Dependents With Assets
 */
export const useDeployedEntityDependentsWithAssets = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deployedEntityDependentsWithAssets>>,
      TError,
      { data: EntityDependentsWithAssetsRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deployedEntityDependentsWithAssets>>,
  TError,
  { data: EntityDependentsWithAssetsRequest },
  TContext
> => {
  const mutationOptions =
    getDeployedEntityDependentsWithAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Deployed Entity Dependency Tree
 */
export const getDeployedEntityDependencyTree = (
  entityType: string,
  entityId: string,
  version: number,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityDependencyTree>(
    {
      url: `/api/entity/deployed/entity-dependents/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/${encodeURIComponent(String(version))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetDeployedEntityDependencyTreeQueryKey = (
  entityType?: string,
  entityId?: string,
  version?: number,
) => {
  return [
    `/api/entity/deployed/entity-dependents/${entityType}/${entityId}/${version}`,
  ] as const;
};

export const getGetDeployedEntityDependencyTreeQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeployedEntityDependencyTreeQueryKey(entityType, entityId, version);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>
  > = ({ signal, meta }) =>
    getDeployedEntityDependencyTree(
      entityType,
      entityId,
      version,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId && version),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeployedEntityDependencyTreeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>
>;
export type GetDeployedEntityDependencyTreeQueryError = ErrorType<unknown>;

export function useGetDeployedEntityDependencyTree<
  TData = Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
          TError,
          Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeployedEntityDependencyTree<
  TData = Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
          TError,
          Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeployedEntityDependencyTree<
  TData = Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Deployed Entity Dependency Tree
 */

export function useGetDeployedEntityDependencyTree<
  TData = Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeployedEntityDependencyTreeQueryOptions(
    entityType,
    entityId,
    version,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Deployed Entity Dependency Tree
 */
export const prefetchGetDeployedEntityDependencyTree = async <
  TData = Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetDeployedEntityDependencyTreeQueryOptions(
    entityType,
    entityId,
    version,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Deployed Entity Snapshot
 */
export const getDeployedEntitySnapshot = (
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/deployed/snapshot/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetDeployedEntitySnapshotQueryKey = (
  entityType?: string,
  entityId?: string,
  params?: GetDeployedEntitySnapshotParams,
) => {
  return [
    `/api/entity/deployed/snapshot/${entityType}/${entityId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDeployedEntitySnapshotQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeployedEntitySnapshotQueryKey(entityType, entityId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeployedEntitySnapshot>>
  > = ({ signal, meta }) =>
    getDeployedEntitySnapshot(
      entityType,
      entityId,
      params,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeployedEntitySnapshotQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeployedEntitySnapshot>>
>;
export type GetDeployedEntitySnapshotQueryError = ErrorType<unknown>;

export function useGetDeployedEntitySnapshot<
  TData = Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params: undefined | GetDeployedEntitySnapshotParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
          TError,
          Awaited<ReturnType<typeof getDeployedEntitySnapshot>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeployedEntitySnapshot<
  TData = Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
          TError,
          Awaited<ReturnType<typeof getDeployedEntitySnapshot>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeployedEntitySnapshot<
  TData = Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Deployed Entity Snapshot
 */

export function useGetDeployedEntitySnapshot<
  TData = Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeployedEntitySnapshotQueryOptions(
    entityType,
    entityId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Deployed Entity Snapshot
 */
export const prefetchGetDeployedEntitySnapshot = async <
  TData = Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetDeployedEntitySnapshotQueryOptions(
    entityType,
    entityId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Deployed Entities
 */
export const searchDeployedEntities = (
  entityType: string,
  query: Query,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/deployed/${encodeURIComponent(String(entityType))}/search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: query,
      signal,
    },
    options,
  );
};

export const getSearchDeployedEntitiesQueryKey = (
  entityType?: string,
  query?: Query,
) => {
  return [`/api/entity/deployed/${entityType}/search`, query] as const;
};

export const getSearchDeployedEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchDeployedEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchDeployedEntitiesQueryKey(entityType, query);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchDeployedEntities>>
  > = ({ signal, meta }) =>
    searchDeployedEntities(
      entityType,
      query,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!entityType,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDeployedEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchDeployedEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchDeployedEntities>>
>;
export type SearchDeployedEntitiesQueryError = ErrorType<unknown>;

export function useSearchDeployedEntities<
  TData = Awaited<ReturnType<typeof searchDeployedEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDeployedEntities>>,
          TError,
          Awaited<ReturnType<typeof searchDeployedEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedEntities<
  TData = Awaited<ReturnType<typeof searchDeployedEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDeployedEntities>>,
          TError,
          Awaited<ReturnType<typeof searchDeployedEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchDeployedEntities<
  TData = Awaited<ReturnType<typeof searchDeployedEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Deployed Entities
 */

export function useSearchDeployedEntities<
  TData = Awaited<ReturnType<typeof searchDeployedEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchDeployedEntitiesQueryOptions(
    entityType,
    query,
    options,
  );

  const _query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  _query.queryKey = queryOptions.queryKey;

  return _query;
}

/**
 * @summary Search Deployed Entities
 */
export const prefetchSearchDeployedEntities = async <
  TData = Awaited<ReturnType<typeof searchDeployedEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDeployedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchDeployedEntitiesQueryOptions(
    entityType,
    query,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Deployed Entity By Id
 */
export const findDeployedEntityById = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/deployed/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getFindDeployedEntityByIdQueryKey = (
  entityType?: string,
  entityId?: string,
) => {
  return [`/api/entity/deployed/${entityType}/${entityId}`] as const;
};

export const getFindDeployedEntityByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof findDeployedEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedEntityById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFindDeployedEntityByIdQueryKey(entityType, entityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findDeployedEntityById>>
  > = ({ signal, meta }) =>
    findDeployedEntityById(
      entityType,
      entityId,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof findDeployedEntityById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindDeployedEntityByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof findDeployedEntityById>>
>;
export type FindDeployedEntityByIdQueryError = ErrorType<unknown>;

export function useFindDeployedEntityById<
  TData = Awaited<ReturnType<typeof findDeployedEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedEntityById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDeployedEntityById>>,
          TError,
          Awaited<ReturnType<typeof findDeployedEntityById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindDeployedEntityById<
  TData = Awaited<ReturnType<typeof findDeployedEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedEntityById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDeployedEntityById>>,
          TError,
          Awaited<ReturnType<typeof findDeployedEntityById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindDeployedEntityById<
  TData = Awaited<ReturnType<typeof findDeployedEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedEntityById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Deployed Entity By Id
 */

export function useFindDeployedEntityById<
  TData = Awaited<ReturnType<typeof findDeployedEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedEntityById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindDeployedEntityByIdQueryOptions(
    entityType,
    entityId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Deployed Entity By Id
 */
export const prefetchFindDeployedEntityById = async <
  TData = Awaited<ReturnType<typeof findDeployedEntityById>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findDeployedEntityById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindDeployedEntityByIdQueryOptions(
    entityType,
    entityId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Detect File Columns
 */
export const detectFileColumns = (
  detectFileColumnsRequest: DetectFileColumnsRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<FileColumn[]>(
    {
      url: `/api/entity/detectFileColumns`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: detectFileColumnsRequest,
      signal,
    },
    options,
  );
};

export const getDetectFileColumnsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof detectFileColumns>>,
    TError,
    { data: DetectFileColumnsRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof detectFileColumns>>,
  TError,
  { data: DetectFileColumnsRequest },
  TContext
> => {
  const mutationKey = ["detectFileColumns"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof detectFileColumns>>,
    { data: DetectFileColumnsRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return detectFileColumns(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type DetectFileColumnsMutationResult = NonNullable<
  Awaited<ReturnType<typeof detectFileColumns>>
>;
export type DetectFileColumnsMutationBody = DetectFileColumnsRequest;
export type DetectFileColumnsMutationError = ErrorType<unknown>;

/**
 * @summary Detect File Columns
 */
export const useDetectFileColumns = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof detectFileColumns>>,
      TError,
      { data: DetectFileColumnsRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof detectFileColumns>>,
  TError,
  { data: DetectFileColumnsRequest },
  TContext
> => {
  const mutationOptions = getDetectFileColumnsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Distinct Values
 */
export const getDistinctValues = (
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/entity/distinct-values`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityDistinctValuesRequest,
      signal,
    },
    options,
  );
};

export const getGetDistinctValuesQueryKey = (
  entityDistinctValuesRequest?: EntityDistinctValuesRequest,
) => {
  return [`/api/entity/distinct-values`, entityDistinctValuesRequest] as const;
};

export const getGetDistinctValuesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDistinctValues>>,
  TError = ErrorType<unknown>,
>(
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDistinctValues>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDistinctValuesQueryKey(entityDistinctValuesRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDistinctValues>>
  > = ({ signal, meta }) =>
    getDistinctValues(
      entityDistinctValuesRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDistinctValues>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDistinctValuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDistinctValues>>
>;
export type GetDistinctValuesQueryError = ErrorType<unknown>;

export function useGetDistinctValues<
  TData = Awaited<ReturnType<typeof getDistinctValues>>,
  TError = ErrorType<unknown>,
>(
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDistinctValues>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDistinctValues>>,
          TError,
          Awaited<ReturnType<typeof getDistinctValues>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDistinctValues<
  TData = Awaited<ReturnType<typeof getDistinctValues>>,
  TError = ErrorType<unknown>,
>(
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDistinctValues>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDistinctValues>>,
          TError,
          Awaited<ReturnType<typeof getDistinctValues>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDistinctValues<
  TData = Awaited<ReturnType<typeof getDistinctValues>>,
  TError = ErrorType<unknown>,
>(
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDistinctValues>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Distinct Values
 */

export function useGetDistinctValues<
  TData = Awaited<ReturnType<typeof getDistinctValues>>,
  TError = ErrorType<unknown>,
>(
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDistinctValues>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDistinctValuesQueryOptions(
    entityDistinctValuesRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Distinct Values
 */
export const prefetchGetDistinctValues = async <
  TData = Awaited<ReturnType<typeof getDistinctValues>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDistinctValues>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetDistinctValuesQueryOptions(
    entityDistinctValuesRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Ai Agent Settings
 */
export const findAiAgentSettings = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    { url: `/api/entity/e_ai_agent_settings`, method: "GET", signal },
    options,
  );
};

export const getFindAiAgentSettingsQueryKey = () => {
  return [`/api/entity/e_ai_agent_settings`] as const;
};

export const getFindAiAgentSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof findAiAgentSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof findAiAgentSettings>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindAiAgentSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findAiAgentSettings>>
  > = ({ signal, meta }) =>
    findAiAgentSettings({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findAiAgentSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindAiAgentSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof findAiAgentSettings>>
>;
export type FindAiAgentSettingsQueryError = ErrorType<unknown>;

export function useFindAiAgentSettings<
  TData = Awaited<ReturnType<typeof findAiAgentSettings>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findAiAgentSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAiAgentSettings>>,
          TError,
          Awaited<ReturnType<typeof findAiAgentSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindAiAgentSettings<
  TData = Awaited<ReturnType<typeof findAiAgentSettings>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findAiAgentSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAiAgentSettings>>,
          TError,
          Awaited<ReturnType<typeof findAiAgentSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindAiAgentSettings<
  TData = Awaited<ReturnType<typeof findAiAgentSettings>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findAiAgentSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Ai Agent Settings
 */

export function useFindAiAgentSettings<
  TData = Awaited<ReturnType<typeof findAiAgentSettings>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findAiAgentSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindAiAgentSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Ai Agent Settings
 */
export const prefetchFindAiAgentSettings = async <
  TData = Awaited<ReturnType<typeof findAiAgentSettings>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findAiAgentSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindAiAgentSettingsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Custom Components
 */
export const searchCustomComponents = (
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/e_custom_component`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customComponentSearchRequest,
      signal,
    },
    options,
  );
};

export const getSearchCustomComponentsQueryKey = (
  customComponentSearchRequest?: CustomComponentSearchRequest,
) => {
  return [
    `/api/entity/e_custom_component`,
    customComponentSearchRequest,
  ] as const;
};

export const getSearchCustomComponentsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchCustomComponents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchCustomComponentsQueryKey(customComponentSearchRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchCustomComponents>>
  > = ({ signal, meta }) =>
    searchCustomComponents(
      customComponentSearchRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchCustomComponents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchCustomComponentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchCustomComponents>>
>;
export type SearchCustomComponentsQueryError = ErrorType<unknown>;

export function useSearchCustomComponents<
  TData = Awaited<ReturnType<typeof searchCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  customComponentSearchRequest: CustomComponentSearchRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchCustomComponents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCustomComponents>>,
          TError,
          Awaited<ReturnType<typeof searchCustomComponents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchCustomComponents<
  TData = Awaited<ReturnType<typeof searchCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchCustomComponents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCustomComponents>>,
          TError,
          Awaited<ReturnType<typeof searchCustomComponents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchCustomComponents<
  TData = Awaited<ReturnType<typeof searchCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchCustomComponents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Custom Components
 */

export function useSearchCustomComponents<
  TData = Awaited<ReturnType<typeof searchCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchCustomComponents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchCustomComponentsQueryOptions(
    customComponentSearchRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Custom Components
 */
export const prefetchSearchCustomComponents = async <
  TData = Awaited<ReturnType<typeof searchCustomComponents>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  customComponentSearchRequest: CustomComponentSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchCustomComponents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchCustomComponentsQueryOptions(
    customComponentSearchRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Namespaces
 */
export const searchNamespaces = (
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/e_i18n_namespace`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: namespaceSearchRequest,
      signal,
    },
    options,
  );
};

export const getSearchNamespacesQueryKey = (
  namespaceSearchRequest?: NamespaceSearchRequest,
) => {
  return [`/api/entity/e_i18n_namespace`, namespaceSearchRequest] as const;
};

export const getSearchNamespacesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchNamespaces>>,
  TError = ErrorType<unknown>,
>(
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNamespaces>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchNamespacesQueryKey(namespaceSearchRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchNamespaces>>
  > = ({ signal, meta }) =>
    searchNamespaces(
      namespaceSearchRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchNamespaces>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchNamespacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchNamespaces>>
>;
export type SearchNamespacesQueryError = ErrorType<unknown>;

export function useSearchNamespaces<
  TData = Awaited<ReturnType<typeof searchNamespaces>>,
  TError = ErrorType<unknown>,
>(
  namespaceSearchRequest: NamespaceSearchRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNamespaces>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNamespaces>>,
          TError,
          Awaited<ReturnType<typeof searchNamespaces>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchNamespaces<
  TData = Awaited<ReturnType<typeof searchNamespaces>>,
  TError = ErrorType<unknown>,
>(
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNamespaces>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNamespaces>>,
          TError,
          Awaited<ReturnType<typeof searchNamespaces>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchNamespaces<
  TData = Awaited<ReturnType<typeof searchNamespaces>>,
  TError = ErrorType<unknown>,
>(
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNamespaces>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Namespaces
 */

export function useSearchNamespaces<
  TData = Awaited<ReturnType<typeof searchNamespaces>>,
  TError = ErrorType<unknown>,
>(
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNamespaces>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchNamespacesQueryOptions(
    namespaceSearchRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Namespaces
 */
export const prefetchSearchNamespaces = async <
  TData = Awaited<ReturnType<typeof searchNamespaces>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  namespaceSearchRequest: NamespaceSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchNamespaces>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchNamespacesQueryOptions(
    namespaceSearchRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Interface Override
 */
export const findInterfaceOverride = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    { url: `/api/entity/e_interface_override`, method: "GET", signal },
    options,
  );
};

export const getFindInterfaceOverrideQueryKey = () => {
  return [`/api/entity/e_interface_override`] as const;
};

export const getFindInterfaceOverrideQueryOptions = <
  TData = Awaited<ReturnType<typeof findInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof findInterfaceOverride>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindInterfaceOverrideQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findInterfaceOverride>>
  > = ({ signal, meta }) =>
    findInterfaceOverride({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findInterfaceOverride>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindInterfaceOverrideQueryResult = NonNullable<
  Awaited<ReturnType<typeof findInterfaceOverride>>
>;
export type FindInterfaceOverrideQueryError = ErrorType<unknown>;

export function useFindInterfaceOverride<
  TData = Awaited<ReturnType<typeof findInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findInterfaceOverride>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findInterfaceOverride>>,
          TError,
          Awaited<ReturnType<typeof findInterfaceOverride>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindInterfaceOverride<
  TData = Awaited<ReturnType<typeof findInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findInterfaceOverride>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findInterfaceOverride>>,
          TError,
          Awaited<ReturnType<typeof findInterfaceOverride>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindInterfaceOverride<
  TData = Awaited<ReturnType<typeof findInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findInterfaceOverride>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Interface Override
 */

export function useFindInterfaceOverride<
  TData = Awaited<ReturnType<typeof findInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findInterfaceOverride>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindInterfaceOverrideQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Interface Override
 */
export const prefetchFindInterfaceOverride = async <
  TData = Awaited<ReturnType<typeof findInterfaceOverride>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findInterfaceOverride>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindInterfaceOverrideQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Fetch Embedded Dependents
 */
export const fetchEmbeddedDependents = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EmbeddedDependentsResponse>(
    {
      url: `/api/entity/embedded-dependents/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getFetchEmbeddedDependentsQueryKey = (
  entityType?: string,
  entityId?: string,
) => {
  return [`/api/entity/embedded-dependents/${entityType}/${entityId}`] as const;
};

export const getFetchEmbeddedDependentsQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFetchEmbeddedDependentsQueryKey(entityType, entityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchEmbeddedDependents>>
  > = ({ signal, meta }) =>
    fetchEmbeddedDependents(
      entityType,
      entityId,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchEmbeddedDependentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchEmbeddedDependents>>
>;
export type FetchEmbeddedDependentsQueryError = ErrorType<unknown>;

export function useFetchEmbeddedDependents<
  TData = Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
          TError,
          Awaited<ReturnType<typeof fetchEmbeddedDependents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchEmbeddedDependents<
  TData = Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
          TError,
          Awaited<ReturnType<typeof fetchEmbeddedDependents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchEmbeddedDependents<
  TData = Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Embedded Dependents
 */

export function useFetchEmbeddedDependents<
  TData = Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchEmbeddedDependentsQueryOptions(
    entityType,
    entityId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetch Embedded Dependents
 */
export const prefetchFetchEmbeddedDependents = async <
  TData = Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmbeddedDependents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFetchEmbeddedDependentsQueryOptions(
    entityType,
    entityId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Embedded Entities
 */
export const searchEmbeddedEntities = (
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EmbeddedDependentsResponse>(
    {
      url: `/api/entity/embedded-entities`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: embeddedEntitiesSearchRequest,
      signal,
    },
    options,
  );
};

export const getSearchEmbeddedEntitiesQueryKey = (
  embeddedEntitiesSearchRequest?: EmbeddedEntitiesSearchRequest,
) => {
  return [
    `/api/entity/embedded-entities`,
    embeddedEntitiesSearchRequest,
  ] as const;
};

export const getSearchEmbeddedEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchEmbeddedEntitiesQueryKey(embeddedEntitiesSearchRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchEmbeddedEntities>>
  > = ({ signal, meta }) =>
    searchEmbeddedEntities(
      embeddedEntitiesSearchRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchEmbeddedEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchEmbeddedEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchEmbeddedEntities>>
>;
export type SearchEmbeddedEntitiesQueryError = ErrorType<unknown>;

export function useSearchEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchEmbeddedEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchEmbeddedEntities>>,
          TError,
          Awaited<ReturnType<typeof searchEmbeddedEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchEmbeddedEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchEmbeddedEntities>>,
          TError,
          Awaited<ReturnType<typeof searchEmbeddedEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Embedded Entities
 */

export function useSearchEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchEmbeddedEntitiesQueryOptions(
    embeddedEntitiesSearchRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Embedded Entities
 */
export const prefetchSearchEmbeddedEntities = async <
  TData = Awaited<ReturnType<typeof searchEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  embeddedEntitiesSearchRequest: EmbeddedEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchEmbeddedEntitiesQueryOptions(
    embeddedEntitiesSearchRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Interface Page Embedded Entities
 */
export const searchInterfacePageEmbeddedEntities = (
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EmbeddedDependentsResponse>(
    {
      url: `/api/entity/embedded-entities/e_component`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: interfacePageEmbeddedRequest,
      signal,
    },
    options,
  );
};

export const getSearchInterfacePageEmbeddedEntitiesQueryKey = (
  interfacePageEmbeddedRequest?: InterfacePageEmbeddedRequest,
) => {
  return [
    `/api/entity/embedded-entities/e_component`,
    interfacePageEmbeddedRequest,
  ] as const;
};

export const getSearchInterfacePageEmbeddedEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchInterfacePageEmbeddedEntitiesQueryKey(
      interfacePageEmbeddedRequest,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>
  > = ({ signal, meta }) =>
    searchInterfacePageEmbeddedEntities(
      interfacePageEmbeddedRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchInterfacePageEmbeddedEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>
>;
export type SearchInterfacePageEmbeddedEntitiesQueryError = ErrorType<unknown>;

export function useSearchInterfacePageEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
          TError,
          Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchInterfacePageEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
          TError,
          Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchInterfacePageEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Interface Page Embedded Entities
 */

export function useSearchInterfacePageEmbeddedEntities<
  TData = Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchInterfacePageEmbeddedEntitiesQueryOptions(
    interfacePageEmbeddedRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Interface Page Embedded Entities
 */
export const prefetchSearchInterfacePageEmbeddedEntities = async <
  TData = Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  interfacePageEmbeddedRequest: InterfacePageEmbeddedRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchInterfacePageEmbeddedEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchInterfacePageEmbeddedEntitiesQueryOptions(
    interfacePageEmbeddedRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Entity Dependency Tree
 */
export const getEntityDependency = (
  entityDependencyRequest: EntityDependencyRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityDependencyTree>(
    {
      url: `/api/entity/entity-dependency`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityDependencyRequest,
      signal,
    },
    options,
  );
};

export const getGetEntityDependencyQueryKey = (
  entityDependencyRequest?: EntityDependencyRequest,
) => {
  return [`/api/entity/entity-dependency`, entityDependencyRequest] as const;
};

export const getGetEntityDependencyQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  entityDependencyRequest: EntityDependencyRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependency>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEntityDependencyQueryKey(entityDependencyRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEntityDependency>>
  > = ({ signal, meta }) =>
    getEntityDependency(
      entityDependencyRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEntityDependency>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntityDependencyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntityDependency>>
>;
export type GetEntityDependencyQueryError = ErrorType<unknown>;

export function useGetEntityDependency<
  TData = Awaited<ReturnType<typeof getEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  entityDependencyRequest: EntityDependencyRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependency>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntityDependency>>,
          TError,
          Awaited<ReturnType<typeof getEntityDependency>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntityDependency<
  TData = Awaited<ReturnType<typeof getEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  entityDependencyRequest: EntityDependencyRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependency>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntityDependency>>,
          TError,
          Awaited<ReturnType<typeof getEntityDependency>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntityDependency<
  TData = Awaited<ReturnType<typeof getEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  entityDependencyRequest: EntityDependencyRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependency>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Entity Dependency Tree
 */

export function useGetEntityDependency<
  TData = Awaited<ReturnType<typeof getEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  entityDependencyRequest: EntityDependencyRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependency>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEntityDependencyQueryOptions(
    entityDependencyRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Entity Dependency Tree
 */
export const prefetchGetEntityDependency = async <
  TData = Awaited<ReturnType<typeof getEntityDependency>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityDependencyRequest: EntityDependencyRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependency>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetEntityDependencyQueryOptions(
    entityDependencyRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Entity Dependents With Assets
 */
export const entityDependentsWithAssets = (
  entityDependentsWithAssetsRequest: EntityDependentsWithAssetsRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityDependentsWithAssetsResponse>(
    {
      url: `/api/entity/entity-dependents-with-assets`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityDependentsWithAssetsRequest,
      signal,
    },
    options,
  );
};

export const getEntityDependentsWithAssetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof entityDependentsWithAssets>>,
    TError,
    { data: EntityDependentsWithAssetsRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof entityDependentsWithAssets>>,
  TError,
  { data: EntityDependentsWithAssetsRequest },
  TContext
> => {
  const mutationKey = ["entityDependentsWithAssets"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof entityDependentsWithAssets>>,
    { data: EntityDependentsWithAssetsRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return entityDependentsWithAssets(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type EntityDependentsWithAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof entityDependentsWithAssets>>
>;
export type EntityDependentsWithAssetsMutationBody =
  EntityDependentsWithAssetsRequest;
export type EntityDependentsWithAssetsMutationError = ErrorType<unknown>;

/**
 * @summary Entity Dependents With Assets
 */
export const useEntityDependentsWithAssets = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof entityDependentsWithAssets>>,
      TError,
      { data: EntityDependentsWithAssetsRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof entityDependentsWithAssets>>,
  TError,
  { data: EntityDependentsWithAssetsRequest },
  TContext
> => {
  const mutationOptions = getEntityDependentsWithAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Entity Dependency Tree
 */
export const getEntityDependencyTree = (
  entityType: string,
  entityId: string,
  version: number,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityDependencyTree>(
    {
      url: `/api/entity/entity-dependents/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/${encodeURIComponent(String(version))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetEntityDependencyTreeQueryKey = (
  entityType?: string,
  entityId?: string,
  version?: number,
) => {
  return [
    `/api/entity/entity-dependents/${entityType}/${entityId}/${version}`,
  ] as const;
};

export const getGetEntityDependencyTreeQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependencyTree>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEntityDependencyTreeQueryKey(entityType, entityId, version);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEntityDependencyTree>>
  > = ({ signal, meta }) =>
    getEntityDependencyTree(
      entityType,
      entityId,
      version,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId && version),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEntityDependencyTree>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntityDependencyTreeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntityDependencyTree>>
>;
export type GetEntityDependencyTreeQueryError = ErrorType<unknown>;

export function useGetEntityDependencyTree<
  TData = Awaited<ReturnType<typeof getEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependencyTree>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntityDependencyTree>>,
          TError,
          Awaited<ReturnType<typeof getEntityDependencyTree>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntityDependencyTree<
  TData = Awaited<ReturnType<typeof getEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependencyTree>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntityDependencyTree>>,
          TError,
          Awaited<ReturnType<typeof getEntityDependencyTree>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntityDependencyTree<
  TData = Awaited<ReturnType<typeof getEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependencyTree>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Entity Dependency Tree
 */

export function useGetEntityDependencyTree<
  TData = Awaited<ReturnType<typeof getEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependencyTree>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEntityDependencyTreeQueryOptions(
    entityType,
    entityId,
    version,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Entity Dependency Tree
 */
export const prefetchGetEntityDependencyTree = async <
  TData = Awaited<ReturnType<typeof getEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDependencyTree>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetEntityDependencyTreeQueryOptions(
    entityType,
    entityId,
    version,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Export Entities
 */
export const exportEntities = (
  entityExportRequest: EntityExportRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<string>(
    {
      url: `/api/entity/exportEntities`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityExportRequest,
      signal,
    },
    options,
  );
};

export const getExportEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportEntities>>,
    TError,
    { data: EntityExportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportEntities>>,
  TError,
  { data: EntityExportRequest },
  TContext
> => {
  const mutationKey = ["exportEntities"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportEntities>>,
    { data: EntityExportRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return exportEntities(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportEntities>>
>;
export type ExportEntitiesMutationBody = EntityExportRequest;
export type ExportEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Export Entities
 */
export const useExportEntities = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof exportEntities>>,
      TError,
      { data: EntityExportRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof exportEntities>>,
  TError,
  { data: EntityExportRequest },
  TContext
> => {
  const mutationOptions = getExportEntitiesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Import Field Mapping
 */
export const getImportFieldMapping = (
  importFieldMappingRequest: ImportFieldMappingRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityImportFieldMapping[]>(
    {
      url: `/api/entity/getImportFieldMapping`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: importFieldMappingRequest,
      signal,
    },
    options,
  );
};

export const getGetImportFieldMappingQueryKey = (
  importFieldMappingRequest?: ImportFieldMappingRequest,
) => {
  return [
    `/api/entity/getImportFieldMapping`,
    importFieldMappingRequest,
  ] as const;
};

export const getGetImportFieldMappingQueryOptions = <
  TData = Awaited<ReturnType<typeof getImportFieldMapping>>,
  TError = ErrorType<unknown>,
>(
  importFieldMappingRequest: ImportFieldMappingRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImportFieldMapping>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetImportFieldMappingQueryKey(importFieldMappingRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getImportFieldMapping>>
  > = ({ signal, meta }) =>
    getImportFieldMapping(
      importFieldMappingRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getImportFieldMapping>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetImportFieldMappingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImportFieldMapping>>
>;
export type GetImportFieldMappingQueryError = ErrorType<unknown>;

export function useGetImportFieldMapping<
  TData = Awaited<ReturnType<typeof getImportFieldMapping>>,
  TError = ErrorType<unknown>,
>(
  importFieldMappingRequest: ImportFieldMappingRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImportFieldMapping>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImportFieldMapping>>,
          TError,
          Awaited<ReturnType<typeof getImportFieldMapping>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetImportFieldMapping<
  TData = Awaited<ReturnType<typeof getImportFieldMapping>>,
  TError = ErrorType<unknown>,
>(
  importFieldMappingRequest: ImportFieldMappingRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImportFieldMapping>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImportFieldMapping>>,
          TError,
          Awaited<ReturnType<typeof getImportFieldMapping>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetImportFieldMapping<
  TData = Awaited<ReturnType<typeof getImportFieldMapping>>,
  TError = ErrorType<unknown>,
>(
  importFieldMappingRequest: ImportFieldMappingRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImportFieldMapping>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Import Field Mapping
 */

export function useGetImportFieldMapping<
  TData = Awaited<ReturnType<typeof getImportFieldMapping>>,
  TError = ErrorType<unknown>,
>(
  importFieldMappingRequest: ImportFieldMappingRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImportFieldMapping>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetImportFieldMappingQueryOptions(
    importFieldMappingRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Import Field Mapping
 */
export const prefetchGetImportFieldMapping = async <
  TData = Awaited<ReturnType<typeof getImportFieldMapping>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  importFieldMappingRequest: ImportFieldMappingRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImportFieldMapping>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetImportFieldMappingQueryOptions(
    importFieldMappingRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Import Entities
 */
export const importEntities = (
  entityImportRequest: EntityImportRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    {
      url: `/api/entity/importEntities`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityImportRequest,
      signal,
    },
    options,
  );
};

export const getImportEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importEntities>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importEntities>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationKey = ["importEntities"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importEntities>>,
    { data: EntityImportRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return importEntities(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof importEntities>>
>;
export type ImportEntitiesMutationBody = EntityImportRequest;
export type ImportEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Import Entities
 */
export const useImportEntities = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importEntities>>,
      TError,
      { data: EntityImportRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof importEntities>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationOptions = getImportEntitiesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Latest Version
 */
export const getLatestVersion = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<GetLatestVersion200>(
    {
      url: `/api/entity/latest-version/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetLatestVersionQueryKey = (
  entityType?: string,
  entityId?: string,
) => {
  return [`/api/entity/latest-version/${entityType}/${entityId}`] as const;
};

export const getGetLatestVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestVersion>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLatestVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLatestVersionQueryKey(entityType, entityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLatestVersion>>
  > = ({ signal, meta }) =>
    getLatestVersion(entityType, entityId, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestVersion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLatestVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestVersion>>
>;
export type GetLatestVersionQueryError = ErrorType<unknown>;

export function useGetLatestVersion<
  TData = Awaited<ReturnType<typeof getLatestVersion>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLatestVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestVersion>>,
          TError,
          Awaited<ReturnType<typeof getLatestVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLatestVersion<
  TData = Awaited<ReturnType<typeof getLatestVersion>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLatestVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestVersion>>,
          TError,
          Awaited<ReturnType<typeof getLatestVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLatestVersion<
  TData = Awaited<ReturnType<typeof getLatestVersion>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLatestVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Latest Version
 */

export function useGetLatestVersion<
  TData = Awaited<ReturnType<typeof getLatestVersion>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLatestVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLatestVersionQueryOptions(
    entityType,
    entityId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Latest Version
 */
export const prefetchGetLatestVersion = async <
  TData = Awaited<ReturnType<typeof getLatestVersion>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLatestVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetLatestVersionQueryOptions(
    entityType,
    entityId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Mutate Entity Id
 */
export const mutateEntityId = (
  entityType: string,
  existingEntityId: string,
  newEntityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/mutateEntityId/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(existingEntityId))}/${encodeURIComponent(String(newEntityId))}`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getMutateEntityIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mutateEntityId>>,
    TError,
    { entityType: string; existingEntityId: string; newEntityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mutateEntityId>>,
  TError,
  { entityType: string; existingEntityId: string; newEntityId: string },
  TContext
> => {
  const mutationKey = ["mutateEntityId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mutateEntityId>>,
    { entityType: string; existingEntityId: string; newEntityId: string }
  > = (props, context) => {
    const { entityType, existingEntityId, newEntityId } = props ?? {};

    return mutateEntityId(entityType, existingEntityId, newEntityId, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type MutateEntityIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof mutateEntityId>>
>;

export type MutateEntityIdMutationError = ErrorType<unknown>;

/**
 * @summary Mutate Entity Id
 */
export const useMutateEntityId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mutateEntityId>>,
      TError,
      { entityType: string; existingEntityId: string; newEntityId: string },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof mutateEntityId>>,
  TError,
  { entityType: string; existingEntityId: string; newEntityId: string },
  TContext
> => {
  const mutationOptions = getMutateEntityIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Parse Column
 */
export const parseColumn = (
  entityImportRequest: EntityImportRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<string[]>(
    {
      url: `/api/entity/parseColumn`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityImportRequest,
      signal,
    },
    options,
  );
};

export const getParseColumnMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof parseColumn>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof parseColumn>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationKey = ["parseColumn"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof parseColumn>>,
    { data: EntityImportRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return parseColumn(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ParseColumnMutationResult = NonNullable<
  Awaited<ReturnType<typeof parseColumn>>
>;
export type ParseColumnMutationBody = EntityImportRequest;
export type ParseColumnMutationError = ErrorType<unknown>;

/**
 * @summary Parse Column
 */
export const useParseColumn = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof parseColumn>>,
      TError,
      { data: EntityImportRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof parseColumn>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationOptions = getParseColumnMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Parse Column Names
 */
export const parseColumnNames = (
  entityImportRequest: EntityImportRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<string[]>(
    {
      url: `/api/entity/parseColumnNames`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityImportRequest,
      signal,
    },
    options,
  );
};

export const getParseColumnNamesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof parseColumnNames>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof parseColumnNames>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationKey = ["parseColumnNames"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof parseColumnNames>>,
    { data: EntityImportRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return parseColumnNames(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ParseColumnNamesMutationResult = NonNullable<
  Awaited<ReturnType<typeof parseColumnNames>>
>;
export type ParseColumnNamesMutationBody = EntityImportRequest;
export type ParseColumnNamesMutationError = ErrorType<unknown>;

/**
 * @summary Parse Column Names
 */
export const useParseColumnNames = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof parseColumnNames>>,
      TError,
      { data: EntityImportRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof parseColumnNames>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationOptions = getParseColumnNamesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Parse Column Names Inline
 */
export const parseColumnNamesInline = (
  entityImportRequest: EntityImportRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<string[]>(
    {
      url: `/api/entity/parseColumnNamesInline`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityImportRequest,
      signal,
    },
    options,
  );
};

export const getParseColumnNamesInlineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof parseColumnNamesInline>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof parseColumnNamesInline>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationKey = ["parseColumnNamesInline"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof parseColumnNamesInline>>,
    { data: EntityImportRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return parseColumnNamesInline(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ParseColumnNamesInlineMutationResult = NonNullable<
  Awaited<ReturnType<typeof parseColumnNamesInline>>
>;
export type ParseColumnNamesInlineMutationBody = EntityImportRequest;
export type ParseColumnNamesInlineMutationError = ErrorType<unknown>;

/**
 * @summary Parse Column Names Inline
 */
export const useParseColumnNamesInline = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof parseColumnNamesInline>>,
      TError,
      { data: EntityImportRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof parseColumnNamesInline>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationOptions = getParseColumnNamesInlineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Parse Column Names With Type
 */
export const parseColumnNamesWithType = (
  entityImportRequest: EntityImportRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<FileColumn[]>(
    {
      url: `/api/entity/parseColumnNamesWithType`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityImportRequest,
      signal,
    },
    options,
  );
};

export const getParseColumnNamesWithTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof parseColumnNamesWithType>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof parseColumnNamesWithType>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationKey = ["parseColumnNamesWithType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof parseColumnNamesWithType>>,
    { data: EntityImportRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return parseColumnNamesWithType(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ParseColumnNamesWithTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof parseColumnNamesWithType>>
>;
export type ParseColumnNamesWithTypeMutationBody = EntityImportRequest;
export type ParseColumnNamesWithTypeMutationError = ErrorType<unknown>;

/**
 * @summary Parse Column Names With Type
 */
export const useParseColumnNamesWithType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof parseColumnNamesWithType>>,
      TError,
      { data: EntityImportRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof parseColumnNamesWithType>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationOptions = getParseColumnNamesWithTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Preview Import
 */
export const previewImport = (
  entityImportRequest: EntityImportRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<ImportPreviewResponse>(
    {
      url: `/api/entity/previewImport`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityImportRequest,
      signal,
    },
    options,
  );
};

export const getPreviewImportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewImport>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewImport>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationKey = ["previewImport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewImport>>,
    { data: EntityImportRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return previewImport(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewImport>>
>;
export type PreviewImportMutationBody = EntityImportRequest;
export type PreviewImportMutationError = ErrorType<unknown>;

/**
 * @summary Preview Import
 */
export const usePreviewImport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewImport>>,
      TError,
      { data: EntityImportRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof previewImport>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationOptions = getPreviewImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Restore Entity From Deployed
 */
export const restoreEntityFromDeployed = (
  entityType: string,
  entityId: string,
  version: number,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/restore/deployed/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/${encodeURIComponent(String(version))}`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getRestoreEntityFromDeployedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreEntityFromDeployed>>,
    TError,
    { entityType: string; entityId: string; version: number },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreEntityFromDeployed>>,
  TError,
  { entityType: string; entityId: string; version: number },
  TContext
> => {
  const mutationKey = ["restoreEntityFromDeployed"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreEntityFromDeployed>>,
    { entityType: string; entityId: string; version: number }
  > = (props, context) => {
    const { entityType, entityId, version } = props ?? {};

    return restoreEntityFromDeployed(entityType, entityId, version, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreEntityFromDeployedMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreEntityFromDeployed>>
>;

export type RestoreEntityFromDeployedMutationError = ErrorType<unknown>;

/**
 * @summary Restore Entity From Deployed
 */
export const useRestoreEntityFromDeployed = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreEntityFromDeployed>>,
      TError,
      { entityType: string; entityId: string; version: number },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restoreEntityFromDeployed>>,
  TError,
  { entityType: string; entityId: string; version: number },
  TContext
> => {
  const mutationOptions = getRestoreEntityFromDeployedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Restore Entity
 */
export const restoreEntity = (
  entityType: string,
  entityId: string,
  version: number,
  params?: RestoreEntityParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/restore/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/${encodeURIComponent(String(version))}`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getRestoreEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreEntity>>,
    TError,
    {
      entityType: string;
      entityId: string;
      version: number;
      params?: RestoreEntityParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreEntity>>,
  TError,
  {
    entityType: string;
    entityId: string;
    version: number;
    params?: RestoreEntityParams;
  },
  TContext
> => {
  const mutationKey = ["restoreEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreEntity>>,
    {
      entityType: string;
      entityId: string;
      version: number;
      params?: RestoreEntityParams;
    }
  > = (props, context) => {
    const { entityType, entityId, version, params } = props ?? {};

    return restoreEntity(entityType, entityId, version, params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreEntity>>
>;

export type RestoreEntityMutationError = ErrorType<unknown>;

/**
 * @summary Restore Entity
 */
export const useRestoreEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreEntity>>,
      TError,
      {
        entityType: string;
        entityId: string;
        version: number;
        params?: RestoreEntityParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restoreEntity>>,
  TError,
  {
    entityType: string;
    entityId: string;
    version: number;
    params?: RestoreEntityParams;
  },
  TContext
> => {
  const mutationOptions = getRestoreEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Search Entity Snapshot
 */
export const searchEntitySnapshot = (
  entityType: string,
  query: Query,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/snapshot/${encodeURIComponent(String(entityType))}/search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: query,
      signal,
    },
    options,
  );
};

export const getSearchEntitySnapshotMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchEntitySnapshot>>,
    TError,
    { entityType: string; data: Query },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchEntitySnapshot>>,
  TError,
  { entityType: string; data: Query },
  TContext
> => {
  const mutationKey = ["searchEntitySnapshot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchEntitySnapshot>>,
    { entityType: string; data: Query }
  > = (props, context) => {
    const { entityType, data } = props ?? {};

    return searchEntitySnapshot(entityType, data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchEntitySnapshotMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchEntitySnapshot>>
>;
export type SearchEntitySnapshotMutationBody = Query;
export type SearchEntitySnapshotMutationError = ErrorType<unknown>;

/**
 * @summary Search Entity Snapshot
 */
export const useSearchEntitySnapshot = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchEntitySnapshot>>,
      TError,
      { entityType: string; data: Query },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchEntitySnapshot>>,
  TError,
  { entityType: string; data: Query },
  TContext
> => {
  const mutationOptions = getSearchEntitySnapshotMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Entity Snapshot
 */
export const getEntitySnapshot = (
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/snapshot/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetEntitySnapshotQueryKey = (
  entityType?: string,
  entityId?: string,
  params?: GetEntitySnapshotParams,
) => {
  return [
    `/api/entity/snapshot/${entityType}/${entityId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEntitySnapshotQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntitySnapshot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEntitySnapshotQueryKey(entityType, entityId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEntitySnapshot>>
  > = ({ signal, meta }) =>
    getEntitySnapshot(
      entityType,
      entityId,
      params,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEntitySnapshot>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntitySnapshotQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntitySnapshot>>
>;
export type GetEntitySnapshotQueryError = ErrorType<unknown>;

export function useGetEntitySnapshot<
  TData = Awaited<ReturnType<typeof getEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params: undefined | GetEntitySnapshotParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntitySnapshot>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitySnapshot>>,
          TError,
          Awaited<ReturnType<typeof getEntitySnapshot>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntitySnapshot<
  TData = Awaited<ReturnType<typeof getEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntitySnapshot>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitySnapshot>>,
          TError,
          Awaited<ReturnType<typeof getEntitySnapshot>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntitySnapshot<
  TData = Awaited<ReturnType<typeof getEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntitySnapshot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Entity Snapshot
 */

export function useGetEntitySnapshot<
  TData = Awaited<ReturnType<typeof getEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntitySnapshot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEntitySnapshotQueryOptions(
    entityType,
    entityId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Entity Snapshot
 */
export const prefetchGetEntitySnapshot = async <
  TData = Awaited<ReturnType<typeof getEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntitySnapshot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetEntitySnapshotQueryOptions(
    entityType,
    entityId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Pull
 */
export const pullEntities = (
  entitySyncPullRequest: EntitySyncPullRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntitySyncPullResponse>(
    {
      url: `/api/entity/sync/pull`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entitySyncPullRequest,
      signal,
    },
    options,
  );
};

export const getPullEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pullEntities>>,
    TError,
    { data: EntitySyncPullRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pullEntities>>,
  TError,
  { data: EntitySyncPullRequest },
  TContext
> => {
  const mutationKey = ["pullEntities"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pullEntities>>,
    { data: EntitySyncPullRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return pullEntities(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type PullEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof pullEntities>>
>;
export type PullEntitiesMutationBody = EntitySyncPullRequest;
export type PullEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Pull
 */
export const usePullEntities = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof pullEntities>>,
      TError,
      { data: EntitySyncPullRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof pullEntities>>,
  TError,
  { data: EntitySyncPullRequest },
  TContext
> => {
  const mutationOptions = getPullEntitiesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Push
 */
export const pushEntities = (
  entitySyncPushRequest: EntitySyncPushRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntitySyncPushResponse>(
    {
      url: `/api/entity/sync/push`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entitySyncPushRequest,
      signal,
    },
    options,
  );
};

export const getPushEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pushEntities>>,
    TError,
    { data: EntitySyncPushRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pushEntities>>,
  TError,
  { data: EntitySyncPushRequest },
  TContext
> => {
  const mutationKey = ["pushEntities"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pushEntities>>,
    { data: EntitySyncPushRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return pushEntities(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type PushEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof pushEntities>>
>;
export type PushEntitiesMutationBody = EntitySyncPushRequest;
export type PushEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Push
 */
export const usePushEntities = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof pushEntities>>,
      TError,
      { data: EntitySyncPushRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof pushEntities>>,
  TError,
  { data: EntitySyncPushRequest },
  TContext
> => {
  const mutationOptions = getPushEntitiesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Entity
 */
export const updateEntity = (
  entity: Entity,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/update`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entity,
      signal,
    },
    options,
  );
};

export const getUpdateEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEntity>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEntity>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationKey = ["updateEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEntity>>,
    { data: Entity }
  > = (props, context) => {
    const { data } = props ?? {};

    return updateEntity(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEntity>>
>;
export type UpdateEntityMutationBody = Entity;
export type UpdateEntityMutationError = ErrorType<unknown>;

/**
 * @summary Update Entity
 */
export const useUpdateEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEntity>>,
      TError,
      { data: Entity },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEntity>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationOptions = getUpdateEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Search Entities
 */
export const searchEntities = (
  entityType: string,
  query: Query,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: query,
      signal,
    },
    options,
  );
};

export const getSearchEntitiesQueryKey = (
  entityType?: string,
  query?: Query,
) => {
  return [`/api/entity/${entityType}`, query] as const;
};

export const getSearchEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchEntitiesQueryKey(entityType, query);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchEntities>>> = ({
    signal,
    meta,
  }) => searchEntities(entityType, query, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!entityType,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof searchEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchEntities>>
>;
export type SearchEntitiesQueryError = ErrorType<unknown>;

export function useSearchEntities<
  TData = Awaited<ReturnType<typeof searchEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEntities>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchEntities>>,
          TError,
          Awaited<ReturnType<typeof searchEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchEntities<
  TData = Awaited<ReturnType<typeof searchEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEntities>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchEntities>>,
          TError,
          Awaited<ReturnType<typeof searchEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchEntities<
  TData = Awaited<ReturnType<typeof searchEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Entities
 */

export function useSearchEntities<
  TData = Awaited<ReturnType<typeof searchEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchEntitiesQueryOptions(
    entityType,
    query,
    options,
  );

  const _query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  _query.queryKey = queryOptions.queryKey;

  return _query;
}

/**
 * @summary Search Entities
 */
export const prefetchSearchEntities = async <
  TData = Awaited<ReturnType<typeof searchEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchEntitiesQueryOptions(
    entityType,
    query,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Archive Entity
 */
export const archiveEntity = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<boolean>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/archive/${encodeURIComponent(String(entityId))}`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getArchiveEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveEntity>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationKey = ["archiveEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveEntity>>,
    { entityType: string; entityId: string }
  > = (props, context) => {
    const { entityType, entityId } = props ?? {};

    return archiveEntity(entityType, entityId, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveEntity>>
>;

export type ArchiveEntityMutationError = ErrorType<unknown>;

/**
 * @summary Archive Entity
 */
export const useArchiveEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveEntity>>,
      TError,
      { entityType: string; entityId: string },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof archiveEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationOptions = getArchiveEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Dependent Entities
 */
export const deleteDependentEntities = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/delete-dependents/${encodeURIComponent(String(entityId))}`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getDeleteDependentEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDependentEntities>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDependentEntities>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationKey = ["deleteDependentEntities"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDependentEntities>>,
    { entityType: string; entityId: string }
  > = (props, context) => {
    const { entityType, entityId } = props ?? {};

    return deleteDependentEntities(entityType, entityId, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDependentEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDependentEntities>>
>;

export type DeleteDependentEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Delete Dependent Entities
 */
export const useDeleteDependentEntities = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDependentEntities>>,
      TError,
      { entityType: string; entityId: string },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDependentEntities>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationOptions = getDeleteDependentEntitiesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Entity
 */
export const deleteEntity = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<boolean>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/delete/${encodeURIComponent(String(entityId))}`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getDeleteEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEntity>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationKey = ["deleteEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEntity>>,
    { entityType: string; entityId: string }
  > = (props, context) => {
    const { entityType, entityId } = props ?? {};

    return deleteEntity(entityType, entityId, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEntity>>
>;

export type DeleteEntityMutationError = ErrorType<unknown>;

/**
 * @summary Delete Entity
 */
export const useDeleteEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEntity>>,
      TError,
      { entityType: string; entityId: string },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationOptions = getDeleteEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find Entities By Ids
 */
export const findEntitiesByIds = (
  entityType: string,
  findByIdsRequest: FindByIdsRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/find-by-ids`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: findByIdsRequest,
      signal,
    },
    options,
  );
};

export const getFindEntitiesByIdsQueryKey = (
  entityType?: string,
  findByIdsRequest?: FindByIdsRequest,
) => {
  return [`/api/entity/${entityType}/find-by-ids`, findByIdsRequest] as const;
};

export const getFindEntitiesByIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof findEntitiesByIds>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  findByIdsRequest: FindByIdsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findEntitiesByIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFindEntitiesByIdsQueryKey(entityType, findByIdsRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findEntitiesByIds>>
  > = ({ signal, meta }) =>
    findEntitiesByIds(
      entityType,
      findByIdsRequest,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!entityType,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof findEntitiesByIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindEntitiesByIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof findEntitiesByIds>>
>;
export type FindEntitiesByIdsQueryError = ErrorType<unknown>;

export function useFindEntitiesByIds<
  TData = Awaited<ReturnType<typeof findEntitiesByIds>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  findByIdsRequest: FindByIdsRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findEntitiesByIds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findEntitiesByIds>>,
          TError,
          Awaited<ReturnType<typeof findEntitiesByIds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindEntitiesByIds<
  TData = Awaited<ReturnType<typeof findEntitiesByIds>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  findByIdsRequest: FindByIdsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findEntitiesByIds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findEntitiesByIds>>,
          TError,
          Awaited<ReturnType<typeof findEntitiesByIds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindEntitiesByIds<
  TData = Awaited<ReturnType<typeof findEntitiesByIds>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  findByIdsRequest: FindByIdsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findEntitiesByIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Entities By Ids
 */

export function useFindEntitiesByIds<
  TData = Awaited<ReturnType<typeof findEntitiesByIds>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  findByIdsRequest: FindByIdsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findEntitiesByIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindEntitiesByIdsQueryOptions(
    entityType,
    findByIdsRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Entities By Ids
 */
export const prefetchFindEntitiesByIds = async <
  TData = Awaited<ReturnType<typeof findEntitiesByIds>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  findByIdsRequest: FindByIdsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findEntitiesByIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindEntitiesByIdsQueryOptions(
    entityType,
    findByIdsRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Save Bulk Entities
 */
export const saveBulkEntities = (
  entityType: string,
  entity: Entity[],
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown[]>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/saveBulkEntities`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entity,
      signal,
    },
    options,
  );
};

export const getSaveBulkEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveBulkEntities>>,
    TError,
    { entityType: string; data: Entity[] },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveBulkEntities>>,
  TError,
  { entityType: string; data: Entity[] },
  TContext
> => {
  const mutationKey = ["saveBulkEntities"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveBulkEntities>>,
    { entityType: string; data: Entity[] }
  > = (props, context) => {
    const { entityType, data } = props ?? {};

    return saveBulkEntities(entityType, data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveBulkEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveBulkEntities>>
>;
export type SaveBulkEntitiesMutationBody = Entity[];
export type SaveBulkEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Save Bulk Entities
 */
export const useSaveBulkEntities = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveBulkEntities>>,
      TError,
      { entityType: string; data: Entity[] },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveBulkEntities>>,
  TError,
  { entityType: string; data: Entity[] },
  TContext
> => {
  const mutationOptions = getSaveBulkEntitiesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Unarchive Entity
 */
export const unarchiveEntity = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<boolean>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/unarchive/${encodeURIComponent(String(entityId))}`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getUnarchiveEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unarchiveEntity>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unarchiveEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationKey = ["unarchiveEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unarchiveEntity>>,
    { entityType: string; entityId: string }
  > = (props, context) => {
    const { entityType, entityId } = props ?? {};

    return unarchiveEntity(entityType, entityId, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type UnarchiveEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof unarchiveEntity>>
>;

export type UnarchiveEntityMutationError = ErrorType<unknown>;

/**
 * @summary Unarchive Entity
 */
export const useUnarchiveEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unarchiveEntity>>,
      TError,
      { entityType: string; entityId: string },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof unarchiveEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationOptions = getUnarchiveEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Entity
 */
export const updateEntityById = (
  entityType: string,
  entityId: string,
  update: Update,
  params?: UpdateEntityByIdParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/update/${encodeURIComponent(String(entityId))}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: update,
      params,
      signal,
    },
    options,
  );
};

export const getUpdateEntityByIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEntityById>>,
    TError,
    {
      entityType: string;
      entityId: string;
      data: Update;
      params?: UpdateEntityByIdParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEntityById>>,
  TError,
  {
    entityType: string;
    entityId: string;
    data: Update;
    params?: UpdateEntityByIdParams;
  },
  TContext
> => {
  const mutationKey = ["updateEntityById"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEntityById>>,
    {
      entityType: string;
      entityId: string;
      data: Update;
      params?: UpdateEntityByIdParams;
    }
  > = (props, context) => {
    const { entityType, entityId, data, params } = props ?? {};

    return updateEntityById(entityType, entityId, data, params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEntityByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEntityById>>
>;
export type UpdateEntityByIdMutationBody = Update;
export type UpdateEntityByIdMutationError = ErrorType<unknown>;

/**
 * @summary Update Entity
 */
export const useUpdateEntityById = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEntityById>>,
      TError,
      {
        entityType: string;
        entityId: string;
        data: Update;
        params?: UpdateEntityByIdParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEntityById>>,
  TError,
  {
    entityType: string;
    entityId: string;
    data: Update;
    params?: UpdateEntityByIdParams;
  },
  TContext
> => {
  const mutationOptions = getUpdateEntityByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find Entity By Id
 */
export const findEntityById = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getFindEntityByIdQueryKey = (
  entityType?: string,
  entityId?: string,
) => {
  return [`/api/entity/${entityType}/${entityId}`] as const;
};

export const getFindEntityByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof findEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findEntityById>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindEntityByIdQueryKey(entityType, entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findEntityById>>> = ({
    signal,
    meta,
  }) =>
    findEntityById(entityType, entityId, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof findEntityById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindEntityByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof findEntityById>>
>;
export type FindEntityByIdQueryError = ErrorType<unknown>;

export function useFindEntityById<
  TData = Awaited<ReturnType<typeof findEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findEntityById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findEntityById>>,
          TError,
          Awaited<ReturnType<typeof findEntityById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindEntityById<
  TData = Awaited<ReturnType<typeof findEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findEntityById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findEntityById>>,
          TError,
          Awaited<ReturnType<typeof findEntityById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindEntityById<
  TData = Awaited<ReturnType<typeof findEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findEntityById>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Entity By Id
 */

export function useFindEntityById<
  TData = Awaited<ReturnType<typeof findEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findEntityById>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindEntityByIdQueryOptions(
    entityType,
    entityId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Entity By Id
 */
export const prefetchFindEntityById = async <
  TData = Awaited<ReturnType<typeof findEntityById>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findEntityById>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindEntityByIdQueryOptions(
    entityType,
    entityId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Deployed Entities
 */
export const deployEntity = (
  entityType: string,
  entityId: string,
  deployEntityRequest: DeployEntityRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/deploy`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deployEntityRequest,
      signal,
    },
    options,
  );
};

export const getDeployEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deployEntity>>,
    TError,
    { entityType: string; entityId: string; data: DeployEntityRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deployEntity>>,
  TError,
  { entityType: string; entityId: string; data: DeployEntityRequest },
  TContext
> => {
  const mutationKey = ["deployEntity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deployEntity>>,
    { entityType: string; entityId: string; data: DeployEntityRequest }
  > = (props, context) => {
    const { entityType, entityId, data } = props ?? {};

    return deployEntity(entityType, entityId, data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type DeployEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deployEntity>>
>;
export type DeployEntityMutationBody = DeployEntityRequest;
export type DeployEntityMutationError = ErrorType<unknown>;

/**
 * @summary Search Deployed Entities
 */
export const useDeployEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deployEntity>>,
      TError,
      { entityType: string; entityId: string; data: DeployEntityRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deployEntity>>,
  TError,
  { entityType: string; entityId: string; data: DeployEntityRequest },
  TContext
> => {
  const mutationOptions = getDeployEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
